var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_c('Header'),_c('Banner'),_c('Newslist'),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-left-fixed",staticStyle:{"position":"fixed","left":"10px","top":"545px","z-index":"99"}},[_c('img',{staticStyle:{"width":"100px","box-shadow":"0 3px 6px 0 rgba(0,0,0,.1)"},attrs:{"src":require("../assets/微信公众号.png"),"alt":""}})])
}]

export { render, staticRenderFns }